export interface ContentPropsState<TProps> {
	contentLoaded: boolean;
	epiContent: TProps;
}

export enum EpiApiActionTypes {
	SET_EPI_PROPS = 'SET_EPI_PROPS',
	SET_EPI_PROPS_FAILED = 'SET_EPI_PROPS_FAILED',

}